import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../utils/Auth';
import API from '../../../utils/API';
import styles from './SimpleRedirect.module.css';

export default function SimpleRedirect() {
    const { userObj } = useAuth();
    const { redirect_url } = userObj;
    
    // React States and Refs
    const [ state, setState ] = useState({
        redirect_url: redirect_url,
        success: '',
        error: '',
        disabled: true,
        hasChanges: false
    });

    // Functions
    const saveRedirectURL = async () => {
        if (state.disabled || !state.redirect_url || !state.hasChanges) return;

        let userEdit = {
            redirect_url: state.redirect_url
        };

        try {
            await API.updateUserObject(userEdit);
            setState(prev => ({...prev, success: 'Update Successful!'}))
        } catch (err) {
            console.error(err);
            setState(prev => ({...prev, error: 'Unable to update url.'}))
        };
    };

    useEffect(() => {
        const re = new RegExp(/[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi)

        if (state.redirect_url.match(re)) {
            setState(prev => ({...prev, disabled: false}))
        } else {
            setState(prev => ({...prev, disabled: true}))
        };

        if (state.redirect_url !== redirect_url) {
            setState(prev => ({...prev, hasChanges: true}));
        } else {
            setState(prev => ({...prev, hasChanges: false}));
        };
        
    },[state.redirect_url]);

    useEffect(() => {
        if (state.success || state.error) {
            const timer = setTimeout(() => {
                setState(prev => ({...prev, success: '', error: ''}))
            }, 2500);

            return () => clearTimeout(timer);
        } return;
    },[state.success, state.error]);
    

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <div className={styles.title}>Redirect URL</div>
                    <div className={styles.subtitle}>Bring attention to your website</div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.inputGroup} style={{flexDirection: 'column'}}>
                    <label className={styles.label}>Website URL (Business)</label>
                    <input
                        type='url'
                        className={styles.input}
                        value={state.redirect_url}
                        onChange={e => setState(prev => ({...prev, redirect_url: e.target.value}))}
                        required
                    />
                </div>
                <div className={styles.inputGroup}>
                    <button
                        className={styles.button}
                        onClick={saveRedirectURL}
                        disabled={state.disabled || userObj?.redirect_url === state.redirect_url}
                    >
                        Save Changes
                    </button>
                    {state.success ? <div className={styles.successMessage} style={{color: 'green'}}>{state.success}</div> : <></>}
                    {state.error ? <div className={styles.errorMessage} style={{color: 'red'}}>{state.error}</div> : <></>}
                </div>
            </div>
        </div>
    );
};